module.exports = __webpack_public_path__ + "static/media/cloud-upload-alt.41139f05.svg";